//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiHelpCircleOutline, mdiMenu, mdiTarget } from '@mdi/js'
import themeConfig from '@themeConfig'

export default {
  setup() {
    const message = ref('Hey!')
    const loading = ref(false)

    const clickMe = () => {
      loading.value = ref(true)
      message.value = 'Wait for it...'

      setTimeout(() => {
        loading.value = false
        message.value = "You've clicked me!"
      }, 2000)
    }

    return {
      message,
      loading,
      clickMe,

      // themeConfig
      appLogo: themeConfig.app.logo,

      icons: {
        mdiHelpCircleOutline,
        mdiMenu,
        mdiTarget,
      },
    }
  },
}
